import { Popover } from 'antd';
import { ReactNode, useMemo, useState } from 'react';

import Checkbox from 'components/checkbox';
import {
  ALL_DEADLINE_FILTER_VALUES,
  DEADLINE_FILTER_OPTIONS,
  DeadlineFilterValue,
} from './deadlineUtils';
import {
  DeadlineFilterDropdownCard,
  DeadlineFilterDropdownGlobalStyles,
  DeadlineFilterOptions,
} from './styles';

interface DeadlineFilterDropdownProps {
  selectedValues: DeadlineFilterValue[];
  onChange: (selectedValues: DeadlineFilterValue[]) => void;
  renderTrigger: (args: { open: boolean }) => ReactNode;
}

const DeadlineFilterDropdown = ({
  selectedValues,
  onChange,
  renderTrigger,
}: DeadlineFilterDropdownProps): JSX.Element => {
  const [open, setOpen] = useState(false);

  const orderedValues = useMemo(() => ALL_DEADLINE_FILTER_VALUES, []);

  const handleToggle = (value: DeadlineFilterValue) => {
    const nextValuesSet = new Set(selectedValues);

    if (nextValuesSet.has(value)) {
      nextValuesSet.delete(value);
    } else {
      nextValuesSet.add(value);
    }

    onChange(orderedValues.filter((optionValue) => nextValuesSet.has(optionValue)));
  };

  const content = (
    <DeadlineFilterDropdownCard>
      <DeadlineFilterOptions>
        {DEADLINE_FILTER_OPTIONS.map((option) => (
          <Checkbox
            key={option.value}
            checked={selectedValues.includes(option.value)}
            controlled
            onChange={() => handleToggle(option.value)}
            label={option.label}
            labelColor="#57575C"
          />
        ))}
      </DeadlineFilterOptions>
    </DeadlineFilterDropdownCard>
  );

  return (
    <>
      <DeadlineFilterDropdownGlobalStyles />
      <Popover
        content={content}
        trigger="click"
        visible={open}
        onVisibleChange={setOpen}
        placement="bottomRight"
        overlayClassName="deadline-filter-dropdown"
        destroyTooltipOnHide
      >
        <span style={{ display: 'inline-flex' }}>{renderTrigger({ open })}</span>
      </Popover>
    </>
  );
};

export default DeadlineFilterDropdown;
